<template>
  <div class="check-vip-wrapper" v-loading="loading">
    <div class="check-vip__title">订单信息</div>
    <div class="check-vip__form">
      <div class="check-vip__item"
        :class="item.type ? 'check-vip__item--' + item.type : ''"
        v-for="item in orderInfo"
        :key="item.field">
        <div class="check-vip__label">{{item.label}}</div>
        <div class="check-vip__value">
          <template v-if="item.type === 'file'">
            <yjh-upload
              :url="baseAPI + '/invoice/do_add'"
              :stopUpload="true"
              :max="10"
              :fileType="['JPG', 'JPEG', 'PNG', 'BMP']"
              overSizeToast="上传文件大小不能超过10M"
              @beforeUpload="handleUpload"
            ></yjh-upload>
          </template>
          <template v-else-if="item.type === 'pic'">
            <img @click="showFullImg=true" :src="item.value" alt="">
            <!-- <img @click="showFullImg=true" src="https://bbs.byr.cn/files/imgupload/2019-03-28-16-35-05.jpg" alt=""> -->
          </template>
          <template v-else><span>{{item.value}}</span></template>
        </div>
        <p v-if="item.type === 'file'" class="check-vip__tips">文件格式支持图片文件(.JPG/.JPEG/.PNG/.BMP)</p>
      </div>
    </div>
    <div class="check-vip__btn" v-if="status === 0">
      <Button type="primary" :disabled="subDisabled" @click="confirm">通过</Button>
    </div>
    <div class="check-vip__btn" v-if="status !== 0">
      <Button type="primary" @click="confirm2" style="width: 100px;">返回列表</Button>
    </div>
    <full-diag :isShow="showFullImg" @close="toggleFullImg(false)">
      <div class="full-img-content">
        <img :src="orderInfo[6] === undefined ? '' : orderInfo[6].value" alt="">
      </div>
    </full-diag>
  </div>
</template>

<script>
import { vipDetail, vipCheck } from '@/api/trade'
import { formatText } from '@/utils/common'
import fullDiag from '@/components/dialogs/fullDiag'
import yjhUpload from '@/components/yjhUpload'

export default {
  name: '',
  components: { fullDiag, yjhUpload },
  data() {
    return {
      subDisabled: false,
      status: Number(this.$route.params.status),
      baseAPI: process.env.VUE_APP_BASE_API,
      loading: true,
      showFullImg: false,
      cust_no: '',
      file: null,
      orderInfo: [
        { field: 'order_no', label: '订单编号', type: '', value: '' },
        { field: 'cust_name', label: '下单用户', type: '', value: '' },
        { field: 'order_memo', label: '服务内容', type: '', value: '' },
        { field: 'pay_type', label: '支付方式', type: '', value: '' },
        { field: 'order_money', label: '订单金额', type: '', value: '' },
        { field: 'order_time', label: '下单时间', type: '', value: '' },
        { field: 'trans_voucher_file_path', label: '转账凭证', type: formatText(this.$route.params.status, ['file', 'pic']), value: '' }
      ]
    }
  },
  computed: {
    statusText() {
      return formatText(this.$route.params.status, ['审核', '查看'])
    }
  },
  mounted() {
    this.getVipDetail()
    this.$store.commit('SET_RETURN_TITLE', this.statusText)
    this.$store.commit('SET_RETURN_TYPE', 'small')
  },
  methods: {
    getVipDetail() {
      this.loading = true
      vipDetail(this.$route.params.order_no).then(res => {
        this.loading = false
        const { code, result } = res
        if (code !== 0) {
          return
        }
        // this.cust_no = result.cust_no
        this.orderInfo.map(item => {
          if (item.field === 'pay_type') {
            item.value = formatText(result.pay_type, ['', '线下转账', '支付宝'])
          } else {
            item.value = result[item.field]
          }
        })
      })
    },
    // 选文件
    handleUpload(file) {
      this.file = file
    },
    confirm() {
      const _this = this
      _this.subDisabled = true
      setTimeout(() => {
        var formData = new FormData()
        formData.append('order_no', _this.$route.params.order_no)
        formData.append('file', _this.file)
        vipCheck(formData).then(res => {
          if (res.code === 0) {
            // _this.$router.push({ name: 'vipPayment' })
            this.$router.go(-1)
          } else {
            _this.$Message.info(res.msg)
            _this.subDisabled = false
          }
        })
      }, 1000)
    },
    confirm2() {
      this.$router.go(-1)
    },
    toggleFullImg(flag) {
      this.showFullImg = flag
    }
  }
}
</script>

<style lang="scss" scoped="">
@import "@/styles/color.scss";
.check-vip-wrapper {
  padding: 10px 120px;
}
.check-vip__title {
  font-size: 14px;
  margin-bottom: 24px;
}
.check-vip__item {
  position: relative;
  padding-left: 72px;
  & + & {
    margin-top: 20px;
  }
  & > * {
    display: inline-block;
    vertical-align: top;
  }
}
.check-vip__label {
  width: 60px;
  text-align: right;
  margin-right: 10px;
  .check-vip__item--file &:before {
    content: '*';
    color: $red;
  }
  &:after {
    content: ':';
  }
  .check-vip__item--file & {
    line-height: 32px;
  }
}
.check-vip__tips {
  margin-top: 10px;
  margin-left: 70px;
  color:#9B9EA0;
}
.check-vip__value {
  max-width: 450px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.check-vip__btn {
  padding-left: 144px;
  margin-top: 30px;
  /deep/ .ivu-btn {
    width: 64px;
  }
}
/deep/ .check-vip__item--file .link-btn {
  line-height: 32px;
  margin-left: 10px;
}
.check-vip__item--pic {
  .check-vip__label {
    line-height: 28px;
  }
  .check-vip__value {
    padding: 4px;
    width: 230px;
    height: 150px;
    border: 1px solid $border;
  }
  img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
</style>
